import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-border-left",
  templateUrl: "./med-icon-border-left.component.html",
})
export class MedIconBorderLeftComponent extends SvgMixinComponent {}
